/* eslint-disable eqeqeq */
import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { get, sumBy } from 'lodash';
import { Popover, PopoverBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import Modal from '../../Modal/ReactBootstrapModal';
import { useStatsig } from '../../hooks/useStatsig';
import DeleteEventFailedPopup from '../../Events/Popups/DeleteEventFailedPopup';
import { resetEvent, publishEvent, unPublishEvent, cloneEvent, deleteEvent, closeDeleteFailedPopup, initDraws, sendSchedulingMessage } from '../../../actions/event-actions';
import { IncompleteApplicationPopup } from '../../PopUps';
import { showErrorPopup } from '../../../actions/notification-actions';
import { showSplash } from '../../../actions/splash-actions';
import PopOverMenu from '../../PopOverMenu';
import styles from '../../../pages/EventProfiles/event.scss';
import Popup from '../../../pages/EventProfiles/popup/popup';
import { EventTypes, isEventType } from '../../../utils/events';
import { ratingTypes } from '../../../utils/constants';
import { clubs } from '../../../../constants';
import { getClickAttrs } from '../../Analytics/gtag';
import { getNewClubPath } from '../../../utils/clubs';
import config from '../../../../config';

const _ = { get, sumBy };

const AdminBar = (props) => {
    const { events } = props;
    const { checkGate, featureGates } = useStatsig();
    const { dispatch } = useDispatch();
    const { adminSplash, currentEvent, deleteEventFailed } = events;
    const event = currentEvent.data;
    const clubTierTypeId = currentEvent.data?.club?.tierTypeId;
    const isPaidHitEvent = isEventType(event, EventTypes.PAID_HIT);
    const isFreePlayEvent = isEventType(event, EventTypes.FREE_PLAY);
    const isFlexLeagueEvent = isEventType(event, EventTypes.FLEX_LEAGUE);
    const isSendDrawNotificationsEnabled = checkGate(featureGates.SEND_DRAW_NOTIFICATIONS);
    const isClubRedirectEnabled = checkGate(featureGates.CLUB_LINKS_REDIRECT);
    const [incompletePopup, setIncompletePopup] = useState();
    const [publishPopover, setPublishPopover] = useState();
    const [initDrawsModal, setInitDrawsModal] = useState(false);
    const [popup, setPopup] = useState({
        show: false,
        popUpMessage: '',
        popUpType: null,
        topPoint: null,
    });

    // admin bar menu items

    let adminBarMenuItems = [];

    if (!_.get(event, 'isDemoEvent', false)) {
        adminBarMenuItems.push({
            label: 'Duplicate Event',
            value: 'clone',
        });
    } else {
        adminBarMenuItems.push({
            label: 'Reset Event',
            value: 'reset_event',
        });
    }

    if (_.get(event, 'registeredPlayers', []).length === 0 &&
        _.get(event, 'withdrawnPlayers', []).length === 0) {
        adminBarMenuItems.push({
            label: 'Delete Event',
            value: 'delete',
        });
    }

    if (event?.published) {
        adminBarMenuItems.push({
            label: 'Unpublish Event',
            value: 'unpublish',
        });
    }

    if (isFlexLeagueEvent && event?.published && event?.eventDivisions?.length > 0 && isSendDrawNotificationsEnabled) {
        adminBarMenuItems.push({
            label: 'Send player match scheduling message',
            value: 'send_scheduling_message',
        });
    }

    adminBarMenuItems = adminBarMenuItems.map(item => {
        return {
            ...item,
            clickCategory: 'Admin Bar',
            clickContext: item.label,
            clickLocation: 'Admin Bar Menu',
        };
    });

    // admin dropdown & actions

    function showPopUp(popUpType, ev) {
        setPopup({
            show: true,
            popUpMessage: popUpType.message,
            popUpType: popUpType.type,
            topPoint: ev ? ev.nativeEvent.pageY : null,
        });
    }

    function handlePopupCancel() {
        setPopup({
            show: false,
            popUpMessage: '',
            popUpType: null,
            topPoint: null,
        });
    }

    async function handleCloneEvent() {
        const res = await props.cloneEvent();
        if (res) {
            props.history.push(`/events/${res.id}/edit?cloned=true`);
        }
    }

    async function handleDeleteEvent() {
        const res = await props.deleteEvent();
        const newClubPath = getNewClubPath(clubTierTypeId);
        if (res) {
            setTimeout(() => {
                if (isClubRedirectEnabled && clubTierTypeId) {
                    dispatch(showSplash);
                    window.location.href = `${config.nextAppHost}/${newClubPath}/${event.club.id}`;
                } else {
                    props.history.push(`/clubs/${event.club.id}`);
                }
            }, 1500);
        }
    }

    function handleUnPublishEvent() {
        setPublishPopover(false);
        props.unPublishEvent();
    }

    function handleResetEvent() {
        props.resetEvent();
    }

    function handlePublishEvent() {
        const clubIsSanctioned = event.club ? event.club.sanctioned : false;
        const paymentsEnabledForClub = event.club ? event.club.paymentsEnabled : false;
        const eventDivisionEntryFeeSum = event?.eventDivisions ? _.sumBy(event.eventDivisions, division => division.entryFee) : 0;
        const eventAllowOffPlatformPayments = event ? event.allowOffPlatformPayments : false;

        if (!(event.eventDivisions?.length)) {
            props.showErrorPopup({
                message: 'Unable to publish event. Please add at least one Event Division.',
            });
        } else if (!(event.eventLocations?.length)) {
            props.showErrorPopup({
                message: 'Unable to publish event. Please add at least one Event Location.',
            });
        } else if (!clubIsSanctioned && event.utrType?.id === 2) {
            setIncompletePopup(true);
        } else if (!paymentsEnabledForClub && eventDivisionEntryFeeSum > 0 && !eventAllowOffPlatformPayments) {
            props.showErrorPopup({
                message: 'Unable to publish event. An active club payment account is required.',
            });
        } else {
            props.publishEvent();
        }
    }

    function handleHeaderPopoverSelect(option) {
        switch (option.value) {
            case 'clone':
                handleCloneEvent();
                break;
            case 'delete': {
                showPopUp({
                    type: 'delete_event',
                    message: 'Deleting this event will mean that no players will be able to search, view or register for this event. You can not retrieve the event in the future.',
                });
                break;
            }
            case 'unpublish':
                showPopUp({
                    type: 'unpublish_event',
                    message: 'Unpublishing this event will mean that no players will be able to search, view or register for this event. You may re-publish the event in the future.',
                });
                break;
            case 'reset_event': {
                showPopUp({
                    type: 'reset_event',
                    message: 'This will delete all divisions, draws and post scores from those draws. This action cannot be undone.',
                });
                break;
            }
            case 'send_scheduling_message': {
                showPopUp({
                    type: 'send_scheduling_message',
                    message: 'Are you sure you want to trigger text & email messages to all players?',
                });
                break;
            }
            default:
                break;
        }
    }

    const handleSendSchedulingMessage = () => {
        props.sendSchedulingMessage(event.id);
    };

    function handlePopUpConfirm() {
        setPopup({
            show: false,
            popUpMessage: '',
        });
        switch (popup.popUpType) {
            case 'delete_event':
                handleDeleteEvent();
                break;
            case 'unpublish_event':
                handleUnPublishEvent();
                break;
            case 'reset_event':
                handleResetEvent();
                break;
            case 'send_scheduling_message':
                handleSendSchedulingMessage();
                break;
            default:
                break;
        }
    }

    function togglePublishPopover() {
        setPublishPopover(!publishPopover);
    }

    function handleEditPopoverClick(option) {
        const step = option.value;
        props.history.push(`/events/${event.id}/edit?step=${step}`);
    }

    async function handleInitDraws() {
        console.log('initDraws');
        await props.initDraws(event.id);
        if (currentEvent.error) {
            // this.closeModal();
        } else {
            props.history.push(`/events/${event.id}/draws?welcome=true`);
        }
    }

    function determineStepNames() {
        return [
            { value: '1', label: 'Step 1: Format & schedule', clickCategory: 'Event Admin', clickContext: 'Edit Event - Step 1', clickLocation: 'Event Profile - Admin Bar' },
            { value: '2', label: 'Step 2: Registration divisions', clickCategory: 'Event Admin', clickContext: 'Edit Event - Step 2', clickLocation: 'Event Profile - Admin Bar' },
            { value: '3', label: 'Step 3: Details', clickCategory: 'Event Admin', clickContext: 'Edit Event - Step 3', clickLocation: 'Event Profile - Admin Bar' },
            { value: '4', label: 'Step 4: Health & safety', clickCategory: 'Event Admin', clickContext: 'Edit Event - Step 4', clickLocation: 'Event Profile - Admin Bar' },
        ];
    }

    const eventSupportsDraws = !isPaidHitEvent && !isFreePlayEvent;
    const showDrawsButton = event.published && (event.eventState.value !== 'pre_registration' && event.eventState.value !== 'open_registration') && event.registeredCount > 0 && eventSupportsDraws;

    return (
        <>
            <div className={`${styles.section} sub-header ${adminSplash ? 'admin-splash bg-teal' : 'bg-transparent'}`}>
                <div className={`container bg-transparent`}>
                    <div className="row">
                        <div
                            className={`col d-flex align-items-center ${adminSplash ? 'justify-content-center' : 'justify-content-between'}`}
                        >
                            {!event.published && !adminSplash && (
                                <div className="content">
                                    <h6 className="text-medium text-gray mb0">DRAFT{event.utrType.id === 2 && event.club.verificationApplicationStatus === clubs.submittedForApproval ? ` - Pending Verified ${ratingTypes.tennis} Approval` : ''}</h6>
                                </div>
                            )}
                            {event.published && !adminSplash && !isPaidHitEvent &&
                                (
                                    <div className="content">
                                        <div className="admin-info">
                                            <div className="title">Status</div>
                                            <div className="h6 text-medium">{event?.eventState.label}</div>
                                        </div>
                                        <div className="admin-info">
                                            <div className="title">Registrations</div>
                                            <div className="h6 text-medium">{event?.registrationsCount || 0}</div>
                                        </div>
                                        <div className="admin-info">
                                            <div className="title">Players</div>
                                            <div className="h6 text-medium">{event?.registeredCount || 0}</div>
                                        </div>
                                        {(event?.eventState.value === 'pre_registration' || event?.eventState.value === 'open_registration') &&
                                            (
                                                <div className="admin-info">
                                                    <div className="title">Registration Ends</div>
                                                    <div className="h6 text-medium">{event?.eventSchedule.registrationEndShort}</div>
                                                </div>
                                            )}
                                        {event?.eventState.value === 'registration_closed' &&
                                            (
                                                <div className="admin-info">
                                                    <div className="title">Event Starts</div>
                                                    <div className="h6 text-medium">{event?.eventSchedule.eventStartShort}</div>
                                                </div>
                                            )}
                                        {(event?.eventState.value === 'in_progress' || event?.eventState.value === 'completed') &&
                                            (
                                                <div className="admin-info">
                                                    <div className="title">Event Ends</div>
                                                    <div className="h6 text-medium">{event?.eventSchedule.eventEndShort}</div>
                                                </div>
                                            )}
                                    </div>
                                )}
                            {!adminSplash && (
                                <div className="buttons">
                                    {adminBarMenuItems.length > 0 && !isFreePlayEvent && (
                                        <PopOverMenu
                                            horizontalEllipsis={true}
                                            menuItems={adminBarMenuItems}
                                            onSelected={handleHeaderPopoverSelect}
                                            alignLeft={false}
                                            popOverMenuClass={'button-float'}
                                            data-testid="event-profile.admin-bar.menu"
                                        >
                                            <button
                                                className={`btn btn-default btn-lg`}
                                                type="button"
                                            >
                                                <span className={`fas fa-ellipsis-h`} />
                                            </button>
                                        </PopOverMenu>
                                    )}
                                    {!event.published && (
                                        <>
                                            <button
                                                type="button"
                                                id="publish"
                                                className={`btn btn-primary btn-lg text-uppercase button-float`}
                                                onClick={togglePublishPopover}
                                                data-testid="event-profile.admin-bar.publish-btn"
                                            >
                                                Publish
                                            </button>
                                            <Popover
                                                placement="bottom"
                                                isOpen={publishPopover}
                                                target="publish"
                                                toggle={togglePublishPopover}
                                            >
                                                <PopoverBody className={'publish-popover text-center p24 theme-v2'}>
                                                    <p className="text-bold text-dark">Ready to publish?</p>
                                                    <p className="text-small text-lighter">Players can view your
                                                        event and register once registration is open.
                                                    </p>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-lg text-uppercase mt8"
                                                        onClick={handlePublishEvent}
                                                        data-testid="event-profile.admin-bar.publish-event-btn"
                                                        {...getClickAttrs({
                                                            category: 'Event Admin',
                                                            context: 'Publish event',
                                                            location: 'Event Profile - Admin Bar',
                                                        })}
                                                    >
                                                        Publish event
                                                    </button>
                                                </PopoverBody>
                                            </Popover>
                                        </>
                                    )}

                                    {isPaidHitEvent || isFreePlayEvent ? (
                                        <div className="button-float">
                                            <button
                                                type="button"
                                                className="btn btn-default btn-lg text-uppercase"
                                                onClick={() => props.history.push(`/events/${event.id}/edit`)}
                                                data-testid="event-profile.admin-bar.edit-event-btn"
                                                {...getClickAttrs({
                                                    category: 'Event Admin',
                                                    context: 'Edit event',
                                                    location: 'Event Profile - Admin Bar',
                                                })}
                                            >
                                                Edit Event
                                            </button>
                                        </div>
                                    ) : (
                                        <PopOverMenu
                                            menuItems={determineStepNames()}
                                            onSelected={handleEditPopoverClick}
                                            popOverMenuClass={'button-float'}
                                            data-testid="event-profile.admin-bar.edit-event-menu"
                                        >
                                            <button type="button" className="btn btn-default btn-lg text-uppercase" data-testid="event-profile.admin-bar.edit-event-dropdown-btn">Edit Event <i className="uts uts-expand mr0" />
                                            </button>
                                        </PopOverMenu>
                                    )}
                                    {showDrawsButton && (
                                        <button
                                            type="button"
                                            className="btn btn-default btn-lg text-uppercase button-float"
                                            onClick={() => {
                                                props.history.push(`/events/${event.id}/draws`);
                                            }}
                                            data-testid="event-profile.admin-bar.event-desk-btn"
                                            {...getClickAttrs({
                                                category: 'Event Profile CTA',
                                                context: 'Draw Button',
                                                location: 'Event Profile - Admin Bar',
                                            })}
                                        >
                                            Event Desk
                                        </button>
                                    )}
                                </div>
                            )}
                            {!!adminSplash &&
                                <h6>{adminSplash}</h6>}
                        </div>
                    </div>
                </div>
            </div>
            {deleteEventFailed && (
                <DeleteEventFailedPopup
                    close={() => props.closeDeleteFailedPopup()}
                    unpublishEvent={() => {
                        props.closeDeleteFailedPopup();
                        handleHeaderPopoverSelect({ value: 'unpublish' });
                    }}
                />
            )}
            {popup.show ? (
                <Popup
                    closePopup={handlePopupCancel}
                    confirmPopup={handlePopUpConfirm}
                    message={popup.popUpMessage}
                    topPoint={popup.topPoint}
                    type={popup.popUpType}
                />
            ) : null}
            {incompletePopup && (
                <IncompleteApplicationPopup
                    onSaveClick={() => setIncompletePopup(false)}
                    onCloseClick={() => setIncompletePopup(false)}
                    buttonText={`Got it`}
                />
            )}
            <Modal visible={initDrawsModal} onClickBackdrop={() => setInitDrawsModal(false)} dialogClassName="modal-lg">
                <div className="modal-header">
                    <div className="text-medium">Create Draws</div>
                    <div className="close-icon" onClick={() => setInitDrawsModal(false)} data-testid="modal.admin-bar.create-draws.close-btn"><i className="utr utr-close" /></div>
                </div>
                <div className="modal-body">
                    <div className="mb24">
                        <ul>
                            <li>Draws will be created for each division with registered players.</li>
                            <li>You will be able to move and place players in draws as you see fit (including creating new draws).</li>
                            <li>If players register after you have initialized draws through this process, you can add them individually to the appropriate draws that have been created.</li>
                        </ul>
                    </div>
                    <button
                        type="button"
                        className={`btn btn-xl btn-block btn-primary`}
                        onClick={handleInitDraws}
                        data-testid="modal.admin-bar.create-draws.confirm-btn"
                    >
                        CREATE DRAWS
                    </button>
                </div>
            </Modal>
        </>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        cloneEvent: () => dispatch(cloneEvent()),
        deleteEvent: () => dispatch(deleteEvent()),
        unPublishEvent: () => dispatch(unPublishEvent()),
        resetEvent: () => dispatch(resetEvent()),
        publishEvent: () => dispatch(publishEvent()),
        showErrorPopup: (data) => dispatch(showErrorPopup(data)),
        closeDeleteFailedPopup: () => dispatch(closeDeleteFailedPopup()),
        initDraws: eventId => dispatch(initDraws(eventId)),
        sendSchedulingMessage: eventId => dispatch(sendSchedulingMessage(eventId)),
    };
}

function mapStateToProps({ events }) {
    return { events };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminBar));
